import React from 'react';

import { CONTENT_DETAIL_KEY } from '../../../../constants/cycleDetail';

import StageForm from '../StageForm/StageForm';
import StageStatusCard from '../StageStatusCard/StageStatusCard';

const StageContent = ({ stage, formData, setFormData, expandedGroups, setExpandedGroups }) => {
    const { name, type, default_version, stage_status } = stage;
    const status_key = stage_status?.status_key;
    const details = default_version?.details || {};

    const key = CONTENT_DETAIL_KEY[type]?.[status_key];
    const data = details?.[key] || [];

    const isFormRendered = !!key;

    if (isFormRendered) {
        return (
            <StageForm
                data={data}
                formData={formData}
                setFormData={setFormData}
                expandedGroups={expandedGroups}
                setExpandedGroups={setExpandedGroups}
            />
        );
    }

    return <StageStatusCard name={name} status_key={status_key} />;
};

export default StageContent;
